var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.miniNav
    ? _c("v-flex", { attrs: { shrink: "" } }, [
        _vm.isGuest
          ? _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "login-button primary--text",
                    attrs: { outlined: "", shrink: "", color: "white" },
                    on: {
                      click: function ($event) {
                        _vm.loginError = false
                        _vm.loginDialog = true
                      },
                    },
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "profile-icon", attrs: { large: "" } },
                      [_vm._v("account_circle")]
                    ),
                    _vm.$vuetify.breakpoint.mdAndUp
                      ? _c("span", [_vm._v("Login")])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-dialog",
                  {
                    attrs: {
                      "max-width": "500px",
                      transition: "dialog-transition",
                    },
                    model: {
                      value: _vm.loginDialog,
                      callback: function ($$v) {
                        _vm.loginDialog = $$v
                      },
                      expression: "loginDialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      {
                        staticClass: "login-window",
                        attrs: { shaped: "", elevation: "5" },
                      },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "align-center bg-primary" },
                          [
                            _c("p", { staticClass: "ml-3 my-0 mr-0 p-0" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.Inserisci_i_tuoi_dati")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", color: "white" },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.loginDialog = false
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("close")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "pb-2" },
                          [
                            _vm.loginError
                              ? _c(
                                  "h3",
                                  {
                                    staticClass: "text-center pa-3",
                                    staticStyle: { color: "red" },
                                    attrs: { transition: "slide-y-transition" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.loginMsg
                                            ? _vm.loginMsg
                                            : _vm.$t(
                                                "message.Dati_inseriti_non_validi"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "v-form",
                              {
                                ref: "loginForm",
                                class: { "mt-5": !_vm.loginError },
                              },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { "grid-list-md": "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          wrap: "",
                                          "justify-center": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                filled: "",
                                                "hide-details": "",
                                                height: "44px",
                                                name: "username",
                                                label: _vm.$t(
                                                  "message.Codice_cliente_o_E-Mail"
                                                ),
                                                rules: [
                                                  _vm.rules.validUsername,
                                                ],
                                              },
                                              model: {
                                                value: _vm.username,
                                                callback: function ($$v) {
                                                  _vm.username = $$v
                                                },
                                                expression: "username",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                filled: "",
                                                "hide-details": "",
                                                height: "44px",
                                                name: "password",
                                                label:
                                                  _vm.$t("message.password"),
                                                "append-icon":
                                                  _vm.passwordVisible
                                                    ? "visibility"
                                                    : "visibility_off",
                                                type: _vm.passwordVisible
                                                  ? "text"
                                                  : "password",
                                              },
                                              on: {
                                                "click:append": function (
                                                  $event
                                                ) {
                                                  _vm.passwordVisible =
                                                    !_vm.passwordVisible
                                                },
                                              },
                                              model: {
                                                value: _vm.password,
                                                callback: function ($$v) {
                                                  _vm.password = $$v
                                                },
                                                expression: "password",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-layout",
                              { attrs: { wrap: "", "justify-end": "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.loginDialog = false
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("message.Chiudi")))]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.login(
                                          _vm.username,
                                          _vm.password
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("LOGIN")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              [
                _c("Profile", {
                  attrs: {
                    darkTheme: _vm.darkTheme,
                    user: _vm.user,
                    currentTab: _vm.currentTab,
                    haveConfigurations: _vm.haveConfigurations,
                    configurations: _vm.configurations,
                  },
                  on: { logout: _vm.logout },
                }),
              ],
              1
            ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }